import { render, staticRenderFns } from "./_productTermsTable.vue?vue&type=template&id=0b061228"
import script from "./_productTermsTable.vue?vue&type=script&lang=js"
export * from "./_productTermsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports